import type { MarketsApi } from "@/v2/api/metadata/markets";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import { displayIdRowFields, marketGamesStatusOptions, marketPositionValidator } from "../../../../shared";
import { marketId, notifySuccess } from "../shared";

const prematchTabChildren: ContentTab["children"] = [
  {
    type: "group",
    name: "prematchGame",
    label: "",
    children: [
      {
        type: "select-field",
        name: "status",
        label: "Status",
        required: true,
        placeholder: "Select status",
        options: marketGamesStatusOptions,
        inheritance: { computedKey: "computedStatus", parentKey: "parentStatus" },
      },
      {
        type: "text-field",
        name: "position",
        label: "Position",
        placeholder: "Enter position",
        validate: marketPositionValidator,
        inheritance: { computedKey: "computedPosition", parentKey: "parentPosition" },
      },
      {
        type: "structured-array-field",
        name: "displayIds",
        label: "Display IDs",
        minItems: 0,
        maxItems: 50,
        inheritance: { computedKey: "computedDisplayIds", parentKey: "parentDisplayIds" },
        children: displayIdRowFields,
      },
    ],
  },
];

export function createPrematchTab(marketsApi: MarketsApi): ContentTab {
  return {
    id: "prematch",
    label: "Prematch",
    save: createInheritableTabSave({
      children: prematchTabChildren,
      persist: async (patch, ctx: DialogTabSaveContext) => {
        await marketsApi.update(marketId(ctx.values), patch);
        notifySuccess();
      },
    }),
    children: prematchTabChildren,
  };
}
